import { render } from "./TicketView.vue?vue&type=template&id=36fe32c5"
import script from "./TicketView.vue?vue&type=script&lang=js"
export * from "./TicketView.vue?vue&type=script&lang=js"

import "./TicketView.vue?vue&type=style&index=0&id=36fe32c5&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__